import { createFileRoute } from "@tanstack/react-router";
import SportTeamsIndex from "@/pages/SportTeamsIndex";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findUsSport } from "@/lib/oddsSports";

export const Route = createFileRoute("/{$sport}-predictions/teams")({
  head: ({ params }) => {
    const sport = findUsSport(params.sport);
    const label = sport?.label ?? readable(params.sport);
    return {
      meta: socialMeta({
        seo: { topics: [params.sport, "teams"] },
        title: `${label} Team Predictions & Odds | Statlign`,
        description: `Every ${label} team with an upcoming modelled fixture, each with its own predictions page showing next games, odds and the model's value edge.`,
        ...(sport ? { image: `https://statlign.com/og-${sport.slug}.jpg` } : {}),
      }),
    };
  },
  component: () => (
    <MainLayout>
      <SportTeamsIndex />
    </MainLayout>
  ),
});
